import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { OrderStatus, PaymentMethod, ShippingMethod, TDeliveryLocation, TMenuItem, TOrder } from '../types';
import parsePrice from '../utils/parsePrice';
import lodash from 'lodash';

type TDefaultOrderFields = {
    status: OrderStatus,
    total: number,
    items: TMenuItem[]
}

const initialState: Partial<TOrder> & TDefaultOrderFields = {
    status: OrderStatus.pending,
    total: 0,
    items: [],
    comment: '',
};

const currentOrderSlice = createSlice({
    name: 'currentOrder',
    initialState,
    reducers: {
        setOrderFromServer: (state, action: PayloadAction<TOrder>) => {
            Object.assign(state, action.payload)
        },
        addItemToOrder: (state, action: PayloadAction<TMenuItem>) => {
            const updatedItemIndex = action.payload.components.length > 0
                ? state.items.findIndex(item => lodash.isEqual(item, action.payload))
                : state.items.findIndex(item => item._id === action.payload._id)
            if (updatedItemIndex > -1) {
                state.items[updatedItemIndex].orderCount += 1;
            } else {
                state.items.push({
                    ...action.payload,
                    orderCount: Math.max(1, action.payload.orderCount)
                })
            }
            state.total = state.items.reduce((acc, item) => acc + parsePrice(item), 0)
        },
        resetOrder: (state) => {
            state._id = undefined;
            state.comment = '';
            state.createdAt = undefined;
            state.code = undefined;
            state.deadlineDate = undefined;
            state.deliveryDate = undefined;
            state.deliveryLocation = undefined;
            state.dineInPlace = undefined;
            state.feedback = undefined;
            state.items = [];
            state.paymentMethod = undefined;
            state.shippingMethod = undefined;
            state.status = OrderStatus.pending;
            state.total = 0;
        },
        removeItemFromOrder: (state, action: PayloadAction<TMenuItem>) => {
            const hasComponents = action.payload.components.length > 0
            let updatedItemIndex = hasComponents
                ? state.items.findIndex(item => lodash.isEqual(item, action.payload))
                : state.items.findIndex(item => lodash.isEqual(item._id, action.payload._id))
            //if (updatedItemIndex === -1) {
            //  updatedItemIndex = state.items.findIndex(item => item._id === action.payload._id)
            //}
            if (updatedItemIndex > -1) {
                if (state.items[updatedItemIndex].orderCount === 1) {
                    state.items = hasComponents
                        ? state.items.filter(item => !lodash.isEqual(item, action.payload))
                        : state.items.filter(item => !lodash.isEqual(item._id, action.payload._id))
                } else {
                    state.items[updatedItemIndex].orderCount -= 1;
                }
            }
            state.total = state.items.reduce((acc, item) => acc + parsePrice(item), 0)
        },
        changeComment: (state, action: PayloadAction<string>) => {
            state.comment = action.payload
        },
        changeShippingMethod: (state, action: PayloadAction<ShippingMethod>) => {
            state.shippingMethod = action.payload
        },
        changePaymentMethod: (state, action: PayloadAction<PaymentMethod>) => {
            state.paymentMethod = action.payload
        },
        changeDeadlineDate: (state, action: PayloadAction<Date>) => {
            state.deadlineDate = action.payload
        },
        changeDeliveryLocation: (state, action: PayloadAction<TDeliveryLocation | undefined>) => {
            state.deliveryLocation = action.payload
        },
        changeDineInPlace: (state, action: PayloadAction<string | undefined>) => {
            state.dineInPlace = action.payload
        },
        changeFeedbackId: (state, action: PayloadAction<string>) => {
            state.feedback = action.payload
        },
    }
})

export default currentOrderSlice;